import { render, staticRenderFns } from "./ListTipoPagamento.vue?vue&type=template&id=d352845e"
import script from "./ListTipoPagamento.vue?vue&type=script&lang=js"
export * from "./ListTipoPagamento.vue?vue&type=script&lang=js"
import style0 from "./ListTipoPagamento.vue?vue&type=style&index=0&id=d352845e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports